/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkOrderBoardTicketDto } from './WorkOrderBoardTicketDto';
import {
    WorkOrderBoardTicketDtoFromJSON,
    WorkOrderBoardTicketDtoFromJSONTyped,
    WorkOrderBoardTicketDtoToJSON,
    WorkOrderBoardTicketDtoToJSONTyped,
} from './WorkOrderBoardTicketDto';

/**
 * 
 * @export
 * @interface WorkOrderBoardCardDto
 */
export interface WorkOrderBoardCardDto {
    /**
     * 
     * @type {string}
     * @memberof WorkOrderBoardCardDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderBoardCardDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderBoardCardDto
     */
    status: WorkOrderBoardCardDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderBoardCardDto
     */
    siteId: string;
    /**
     * External OT number (Monprojet Ordre d’exécution)
     * @type {object}
     * @memberof WorkOrderBoardCardDto
     */
    externalIdentifier?: object | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderBoardCardDto
     */
    assignedTechnicianId?: object | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkOrderBoardCardDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkOrderBoardCardDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkOrderBoardCardDto
     */
    completedAt?: Date | null;
    /**
     * 
     * @type {Array<WorkOrderBoardTicketDto>}
     * @memberof WorkOrderBoardCardDto
     */
    tickets: Array<WorkOrderBoardTicketDto>;
}


/**
 * @export
 */
export const WorkOrderBoardCardDtoStatusEnum = {
    Planned: 'PLANNED',
    Assigned: 'ASSIGNED',
    InProgress: 'IN_PROGRESS',
    OnHold: 'ON_HOLD',
    Completed: 'COMPLETED',
    Closed: 'CLOSED',
    Archived: 'ARCHIVED',
    Cancelled: 'CANCELLED'
} as const;
export type WorkOrderBoardCardDtoStatusEnum = typeof WorkOrderBoardCardDtoStatusEnum[keyof typeof WorkOrderBoardCardDtoStatusEnum];


/**
 * Check if a given object implements the WorkOrderBoardCardDto interface.
 */
export function instanceOfWorkOrderBoardCardDto(value: object): value is WorkOrderBoardCardDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('siteId' in value) || value['siteId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('tickets' in value) || value['tickets'] === undefined) return false;
    return true;
}

export function WorkOrderBoardCardDtoFromJSON(json: any): WorkOrderBoardCardDto {
    return WorkOrderBoardCardDtoFromJSONTyped(json, false);
}

export function WorkOrderBoardCardDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkOrderBoardCardDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'status': json['status'],
        'siteId': json['siteId'],
        'externalIdentifier': json['externalIdentifier'] == null ? undefined : json['externalIdentifier'],
        'assignedTechnicianId': json['assignedTechnicianId'] == null ? undefined : json['assignedTechnicianId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'tickets': ((json['tickets'] as Array<any>).map(WorkOrderBoardTicketDtoFromJSON)),
    };
}

export function WorkOrderBoardCardDtoToJSON(json: any): WorkOrderBoardCardDto {
    return WorkOrderBoardCardDtoToJSONTyped(json, false);
}

export function WorkOrderBoardCardDtoToJSONTyped(value?: WorkOrderBoardCardDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'status': value['status'],
        'siteId': value['siteId'],
        'externalIdentifier': value['externalIdentifier'],
        'assignedTechnicianId': value['assignedTechnicianId'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'completedAt': value['completedAt'] == null ? value['completedAt'] : value['completedAt'].toISOString(),
        'tickets': ((value['tickets'] as Array<any>).map(WorkOrderBoardTicketDtoToJSON)),
    };
}

